<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.settings.sharing.title` | trans }}
    </h1>
    <a slot="buttons" :href="routes.settings" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      {{ `app.back`|trans }}
    </a>
    <v-alert :value="showAlert" :type="`error`" class="mt-4" :dismissible="true">
      {{alertText | trans}}
    </v-alert>
    <v-app id="vuetify-app">
      <v-tabs icons-and-text v-model="selectedTab" slider-color="success" ref="tabs">
        <v-tab>
          {{ `app.sharing.shared_by_me`| trans }}
          <v-icon>keyboard_double_arrow_up</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.sharing.shared_with_me`| trans }}
          <v-icon>keyboard_double_arrow_down</v-icon>
        </v-tab>
        <v-tab-item :key="`shared_by_me`">
          <shared-by-me-table ref="sharedByMeTable"></shared-by-me-table>
        </v-tab-item>
        <v-tab-item :key="`shared_with_me`">
          <shared-with-me-table ref="sharedWithMeTable"></shared-with-me-table>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </base-layout>
</template>

<script>

import {trans} from "../../../app";

export default {
  props: {
    routes: Object,
    acceptanceStatus: {
      type: String,
      required: false,
      default: null,
    }
  },
  data: () => ({
    selectedTab: 0,
    showAlert: false,
    alertText: '',
  }),
  async mounted() {
    if (this.acceptanceStatus) {
      this.selectedTab = 1;
      switch (this.acceptanceStatus) {
        case 'invalid_signature':
          this.showAlert = true;
          this.alertText = 'app.sharing.invalid_signature';
          break;
        case 'already_accepted':
          this.showAlert = true;
          this.alertText = 'app.sharing.already_accepted';
          break;
        case 'self_accept':
          this.showAlert = true;
          this.alertText = 'app.sharing.self_accept';
          break;
        case 'limit':
          this.showAlert = true;
          this.alertText = 'app.sharing.limit';
          break;
        case 'already_sharing':
          this.showAlert = true;
          this.alertText = 'app.sharing.already_sharing';
          break;
        case 'success':
          this.$toast.success(trans('app.sharing.success'));
          break;
      }
      return;
    }
    await this.$refs.sharedByMeTable.fetchData();
    await this.$nextTick();
    this.$refs.tabs && this.$refs.tabs.onResize();
  },
  watch: {
    selectedTab: {
      handler() {
        if (this.selectedTab === 0) {
          this.$refs.sharedByMeTable.fetchData();
        }
        if (this.selectedTab === 1) {
          this.$refs.sharedWithMeTable.fetchData();
        }
      }
    }
  }
}
</script>
